import React from "react"
import moduleImporter from "./moduleImporter"

const componentParser = (
  data = [],
  extraProps = {},
  parentsName = "",
  randomGeneration = true
) => {
  if (!data || !data.length || data.length === 0) {
    return null
  }

  let clonedExtraProps = { ...extraProps
  }

  return data.map(({
    name='',
    props
  }, index) => {
    // This dynamically imports the component
    if (name && name!='') {
      let Component = moduleImporter(name)
      if (!Component) {
        console.error(`${name} tried to render but was not found`)
        return null
      }
      // if there is a scenario we want to move something to children
      // like ColumnGroup to Column/Section
      if (clonedExtraProps.children) delete clonedExtraProps.children
      if (clonedExtraProps.children) delete clonedExtraProps.components

      // Legacy issue, we don't want to pass fullWidth to Button from Section
      if (parentsName === "Section" && name === "Button") {
        if (clonedExtraProps.fullWidth) delete clonedExtraProps.fullWidth
      }

      let key = `${name}-${index}`
      if (randomGeneration){
        key = `${key}-${Math.floor(Math.random() * 100000)}`
      }

      return <Component
        key = {key}
        { ...clonedExtraProps }
        { ...props }
      />
    }
    return null
  })
}



export default componentParser



// WEBPACK FOOTER //
// ./src/AtomicUtils/componentParser.js